import React, { useEffect, useState } from 'react'
import cn from 'clsx'
import { ArrowLeft } from '@corecomponents/icons'
import { LOCATED_FROM } from '@utils/enum'
import { TERMS_CONDITIONS } from '@utils/translation'
import { termConditionData, termConditionStats } from '@utils/TermAndCondition'
import { XMarkIcon } from '@heroicons/react/24/solid'
import DialogModal from 'common/DialogModal'
import { Typography } from '@pw-tech/omni-ui'

type TermConditionModelProps = {
  onClose: () => void
  isTermOpen: boolean
  cameFrom: string
}

const TermConditionModel: React.FC<TermConditionModelProps> = ({
  onClose,
  isTermOpen,
  cameFrom,
}) => {
  const [data, setDate] = useState<any[]>()

  const classNameDialog = cn(
    `rounded-[10px] overflow-scroll scrollbar-hide pb-4`,
    {
      ['w-[480px] h-[500px]']: cameFrom === LOCATED_FROM.REGISTRATION,
      ['w-[720px] h-[400px]']: cameFrom === LOCATED_FROM.STATISTICS,
    }
  )

  const classNameHeader = cn(
    `flex justify-between  cursor-pointer border-b border-[#D9DCE1] py-2 px-5`,
    {
      ['sticky top-0 bg-[#fff]']: cameFrom === LOCATED_FROM.REGISTRATION,
    }
  )

  useEffect(() => {
    if (cameFrom === LOCATED_FROM.REGISTRATION) {
      setDate(termConditionData)
    } else if (cameFrom === LOCATED_FROM.STATISTICS) {
      setDate(termConditionStats)
    }
  }, [])

  return (
    <DialogModal
      dialogPanelClassName={classNameDialog}
      isOpen={isTermOpen}
      onClose={onClose}
    >
      <div className={classNameHeader} role="presentation" onClick={onClose}>
        <div className="flex gap-2">
          {cameFrom === LOCATED_FROM.REGISTRATION && (
            <ArrowLeft className="my-auto " />
          )}

          <Typography variant={'heading4'} weight={'bold'} color="#1B2124">
            {TERMS_CONDITIONS}
          </Typography>
        </div>
        <XMarkIcon height={22} width={24} className="my-auto" />
      </div>
      <div className="px-[32px] pb-4">
        {data?.map((res: any) => {
          return (
            <>
              {res?.topic && (
                <div className="my-4">
                  <Typography
                    variant={'heading4'}
                    weight={'bold'}
                    color="#3D3D3D"
                  >
                    {res?.topic}
                  </Typography>
                </div>
              )}
              <div className="my-2">
                <Typography
                  variant={'regular'}
                  weight={'medium'}
                  color="#3D3D3D"
                  dangerouslySetInnerHTML={{
                    __html: res?.description,
                  }}
                ></Typography>
              </div>
            </>
          )
        })}
      </div>
    </DialogModal>
  )
}

export default React.memo(TermConditionModel)
